// 埋点公参
export const publicParams = {
  user_id: sessionStorage.getItem("uid") || "",
  course_id: "课程ID-包括在读课id、续报课id、联报课id",
  class_type: "1原班推荐2非原班推荐",
};
